import { ApiUtility } from "../../Utilities/ApiUtility.axios";

export enum AssetStatus {
  All,
  Active,
  Disposed,
  Deleted,
}

export enum Asset_Type {
  Single,
  Collective,
  All,
}
export enum AssetPurchase_Type {
  NewPurchase,
  OldPurchase,
  All,
}

export const appendObjectToFormData = (
  formData: any,
  obj: any,
  parentKey = ""
) => {
  for (const key in obj) {
    if (obj.hasOwnProperty(key)) {
      const propKey = parentKey ? `${parentKey}[${key}]` : key;
      if (typeof obj[key] === "object" && obj[key] !== null) {
        appendObjectToFormData(formData, obj[key], propKey);
      } else {
        formData.append(propKey, obj[key]);
      }
    }
  }
};

class FixedAssetsServiceNew {
  route = `V1/API/Billing/Acc_New_FixedAsset`;

  // Get Initial data and edit by id
  getFixedAsset = (companyId: string, id?: string, isDisposed?: boolean) =>
    ApiUtility.get(
      `${this.route}/${companyId}/?${
        id ? `id=${id}&` : ""
      }isDisposed=${isDisposed}`
    );

  getAssetMaxNo = (
    companyId: string,
    voucherDate?: string,
    VoucherTitle?: string
  ) =>
    ApiUtility.get(
      `${this.route}/${companyId}/GetAssetMaxNo/?voucherDate=${voucherDate}`,
      {
        VoucherTitle,
      }
    );

  getAssetDetails = (companyId: string | undefined, id: string) =>
    ApiUtility.get(`${this.route}/${companyId}?id=${id}`);

  getParentAssetsList = (companyId: string | undefined) =>
    ApiUtility.get(`${this.route}/${companyId}/GetParentAssetsList`);

  PostFixedAssets = (companyId: string, params: any, id?: any) =>
    ApiUtility.postForm(
      `${this.route}/${companyId}${id ? "/" + id : ""}`,
      params
    );

  getChildAssetList = (
    companyId: string | undefined,
    from: string,
    to: string,
    start: number,
    length: number,
    sortCol?: any,
    sortDir?: string,
    search?: string,
    type?: Asset_Type,
    status?: any,
    purchaseType: AssetPurchase_Type = AssetPurchase_Type.All
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetChildAssetList`, {
      from,
      to,
      start,
      length,
      sortCol,
      sortDir,
      search,
      type,
      status,
      purchaseType,
    });

  getFixedAssetsList = (
    companyId: string,
    start: number,
    length: number,
    sortCol: any,
    sortDir: string,
    search: string,
    status: AssetStatus
    // type?: string,
    // lastAccDate?: string,
    // isDispose?: boolean
  ) =>
    ApiUtility.getResult(`${this.route}/${companyId}/GetList`, {
      start,
      length,
      sortCol,
      sortDir,
      search,
      status,
      // type,
      // lastAccDate,
      // isDispose,
    });

  // searchAsset = (clientId: string, term?: string, length?: number) =>
  //   ApiUtility.get(`${this.route}/${clientId}/SearchAsset`, { term, length });

  postDispose = (companyId: string, params: any) =>
    ApiUtility.post(`${this.route}/${companyId}/Disposalentry`, params);

  // reActivateAsset = (clientId: string, id: string) =>
  //   ApiUtility.post(
  //     `${this.route}/${clientId}/${id}/Activate`,
  //     id
  //   );
}
export default new FixedAssetsServiceNew();
